export default __webpack_public_path__ + "static/media/yeezy2.288ce9eb.jpg";